import React, { Component } from 'react';
import Combo from './Combo';
import DomicilioCheck from './DomicilioCheck';

class Domicilio extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { data, domiciliosCombos, seleccionarCombo, selectCheckDomicilio, esModificacion, funcionEdicion } = this.props;
        const { domicilio, validaCamposEdicion } = data;

        let errorCheckPrepago = false;
        let errorCheckCredito = false;
        let finalMensajeValidacionCheck = "";

        if(data.domicilio.prepagoCheck){
            errorCheckPrepago= !data.tarjeta_prepaga.some(c=>c.Check);
        }

        if(data.domicilio.creditoCheck){
            errorCheckCredito= !data.tarjeta_credito.some(c=>c.Check);
        }

        if(errorCheckPrepago && ! errorCheckCredito) finalMensajeValidacionCheck = " la cuenta prepaga";
        else if(!errorCheckPrepago &&  errorCheckCredito) finalMensajeValidacionCheck = " la cuenta crédito";
        else if(errorCheckPrepago && errorCheckCredito) finalMensajeValidacionCheck = " las cuentas";

        debugger
        return (
            <div className='modalDomicilioInterior'>
                <div className='bottom-separator modalTelefonosEncabezado bottom-separator-xxs light-grey-background'>
                    {!esModificacion ? <h1>Carga una nueva dirección</h1> : <h1>Modificación de dirección</h1>}
                </div>
                <div className='modalPostalCuerpo'>
                    <div className="col-xs-12 bottom-separator-xs" >
                        <label className="label-primary">{"Calle"}</label>
                        <input
                            className="form-control default-input"
                            value={data.calleEdicion}
                            maxLength={50}
                            onChange={(e)=>funcionEdicion("calleEdicion",e.target.value)}
                        />
                        {validaCamposEdicion.calle == false && <label className='error'>Debe ingresar una Calle</label>}
                    </div>
                    <div className="col-xs-12 bottom-separator-xs" >
                        <div className="row">
                            <div className="col-xs-6">
                                <label className="label-primary">{"Altura"}</label>
                                <input
                                    className="form-control default-input"
                                    value={data.alturaEdicion}
                                    maxLength={50}
                                    onChange={(e)=>funcionEdicion("alturaEdicion",e.target.value)}
                                />
                                {validaCamposEdicion.altura == false && <label className='error'>Debe ingresar la Altura</label>}
                            </div>


                            <div className="col-xs-6">
                                <label className="label-primary">{"Piso"}</label>
                                <input
                                    className="form-control default-input"
                                    value={data.pisoEdicion}
                                    maxLength={50}
                                    onChange={(e)=>funcionEdicion("pisoEdicion",e.target.value)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 bottom-separator-xs" >
                        <div className="row">
                            <div className="col-xs-6">
                                <label className="label-primary">{"Departamento"}</label>
                                <input
                                    className="form-control default-input"
                                    value={data.deptoEdicion}
                                    maxLength={50}
                                    onChange={(e)=>funcionEdicion("deptoEdicion",e.target.value)}
                                />
                            </div>


                            <div className="col-xs-6">
                                <Combo
                                validaCamposEdicion={validaCamposEdicion.codigoPostalId}
                                mensajeErrorValidacion={"Debe ingresar un  Código Postal"} 
                                campo={'codigoPostalId'} 
                                titulo={"Código Postal"} 
                                infoData={data.domicilioComponentes.codigoPostalRows} 
                                selectCombo={this.props.funcionEdicion} 
                                selecciones ={data}
                                width100={true}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 bottom-separator-xs" >
                        <div className="row">
                            <div className="col-xs-6">
                                <label className="label-primary">{"Localidad"}</label>
                                <input
                                    className="form-control default-input"
                                    value={data.localidadEdicion}
                                    maxLength={50}
                                    onChange={(e)=>funcionEdicion("localidadEdicion",e.target.value)}
                                />
                                {validaCamposEdicion.localidad == false && <label className='error'>Debe ingresar la Localidad</label>}
                            </div>


                            <div className="col-xs-6">
                                <Combo
                                validaCamposEdicion={validaCamposEdicion.provinciaId}
                                mensajeErrorValidacion={"Debe ingresar una Provincia"} 
                                campo={'provinciaId'} 
                                titulo={"Provincia"} 
                                infoData={data.domicilioComponentes.provinciaRows} 
                                selectCombo={this.props.funcionEdicion} 
                                selecciones ={data}
                                width100={true}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-xs-12 bottom-separator-xs" >
                        
                        <Combo
                        validaCamposEdicion={validaCamposEdicion.paisId}
                        mensajeErrorValidacion={"Debe ingresar un País"} 
                        campo={'paisId'} 
                        titulo={"País"} 
                        infoData={data.domicilioComponentes.paisRows} 
                        selectCombo={this.props.funcionEdicion} 
                        selecciones ={data}
                        width100={true}
                        />
                       
                    </div>

                    <div className="col-xs-12 bottom-separator-xs" >
                        <div className= 'procesoColumnRight'>
                            <div > <label className="label-primary">{"Comentarios Adicionales (opcional)"}</label></div>
                            <div ><label className="label-primary">{(data.comentariosDomicilioEdicion ? data.comentariosDomicilioEdicion.length : 0)  + "/4000"}</label></div>
                        </div>
                        <textarea
                            className='textAreaComentariosEdicionCliente'
                            style={{height:"62px"}}
                            placeholder="Ingrese comentarios..."
                            value={data.comentariosDomicilioEdicion}
                            maxLength={4000}
                            onChange={(e)=>funcionEdicion("comentariosDomicilioEdicion",e.target.value)}
                        />
                    </div>

                    
                    <div className="col-xs-12 bottom-separator-xs" >
                        <DomicilioCheck data={data} domicilioObj={domiciliosCombos} selectCheckBox={selectCheckDomicilio} />
                        {validaCamposEdicion.checkDomicilioPrepago == false && <label className='error'>{"Debe seleccionar al menos un tipo de domicilio " + finalMensajeValidacionCheck}</label>}
                        {validaCamposEdicion.domicilioLegalPrepaga == true && validaCamposEdicion.modificacionesDomicilio == false && <label className='error'>{"No se realizaron modificaciones"}</label>}
                        {validaCamposEdicion.domicilioLegalPrepaga == false && <label className='error'>{"No puede desafectarse el domicilio legal de la cuenta prepaga por modificación, debe reemplazarse por uno nuevo"}</label>}
                    </div>


                </div>
                <div className='footerTelefonosModal'>
                    <button onClick={() => this.props.funcionCancelar("abrir","POSTAL")} className='btn btn-secondary'>Cancelar</button>
                    <button onClick={() => this.props.funcionAceptar("POSTAL", esModificacion)} className='btn btn-cta'>Aceptar</button>
                </div>
            </div>
        );
    }
}

export default Domicilio;
